import React from "react";
import { ComingSoon } from "../ComingSoon";
import "./InProgress.css";

export const AcceptedPapers = () => {
  return (
    <div className="in-progress-page-layout">
      <div className="in-progress-page-content">
        <ComingSoon />
      </div>
    </div>
  );
};
